let scrollRestorationConfigured = false;

function configureScrollRestoration() {
  if (scrollRestorationConfigured || typeof window === "undefined") return;
  scrollRestorationConfigured = true;

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
}

function clearLocationHash() {
  if (typeof window === "undefined" || !window.location.hash) return;

  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}${window.location.search}`,
  );
}

/** Instant jump to top — bypasses CSS scroll-behavior. Use for route changes. */
export function scrollToTopInstant() {
  configureScrollRestoration();

  if (typeof window === "undefined") return;

  const html = document.documentElement;
  const body = document.body;
  const htmlBehavior = html.style.scrollBehavior;
  const bodyBehavior = body.style.scrollBehavior;

  html.style.scrollBehavior = "auto";
  body.style.scrollBehavior = "auto";

  window.scrollTo(0, 0);
  html.scrollTop = 0;
  body.scrollTop = 0;

  html.style.scrollBehavior = htmlBehavior;
  body.style.scrollBehavior = bodyBehavior;

  clearLocationHash();
}

export function scrollToTop({ behavior = "auto" } = {}) {
  configureScrollRestoration();

  if (typeof window === "undefined") return;

  if (behavior === "auto") {
    scrollToTopInstant();
    return;
  }

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReducedMotion) {
    scrollToTopInstant();
    return;
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  clearLocationHash();
}

/** Ensures top position sticks after React route paint / browser scroll restore. */
export function scrollToTopAfterPaint() {
  scrollToTopInstant();
  requestAnimationFrame(scrollToTopInstant);
}

export function scrollToElement(element, { behavior = "smooth", offset = 0 } = {}) {
  if (!element || typeof window === "undefined") return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const scrollBehavior = prefersReducedMotion || behavior === "auto" ? "auto" : behavior;
  const top = element.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({
    top: Math.max(0, top),
    left: 0,
    behavior: scrollBehavior,
  });
}
